const meta = {
  datasets: 'Datasets',
  behaviors: 'Behaviors',
  'head-sampling': 'Head sampling',
  'tail-sampling': 'Tail sampling',
};

export default meta;
